import { render, staticRenderFns } from "./EmployeeCompliance.vue?vue&type=template&id=11f58254&"
import script from "./EmployeeCompliance.vue?vue&type=script&lang=js&"
export * from "./EmployeeCompliance.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeCompliance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports